import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { fetchCampaignMembers } from '../api-client';
import type { CampaignMember } from '../components/types';

export function useLauncherMembers(id: string) {
  const { apiFetch } = useApi();

  const query = useQuery<CampaignMember[]>({
    queryKey: ['launcher', 'campaigns', id, 'members'],
    queryFn: () => fetchCampaignMembers(apiFetch, id),
    enabled: !!id,
    staleTime: 0,
  });

  return {
    members: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  } as const;
}
